var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"document"},[_c('WebClient_Document',{attrs:{"msg":"Welcome to Web & Document System"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }